// import food from "../assets/img/Food.svg";
// import wine from "../assets/img/Wine_1.svg";
// import beverages from "../assets/img/Beverages.svg";
// import drinks from "../assets/img/Drinks.svg";
// import spirits from "../assets/img/Spirit.svg";
// import mixers from "../assets/img/Mixtures.svg";
export const getSectionIcon = (name) => {
  switch (name?.toLowerCase()) {
    case "food":
      return "fas fa-utensils";
    case "wine":
      return "fas fa-glass-cheers";
    case "beer":
      return "fas fa-beer";
    case "beverages":
      return "fas fa-coffee";
    case "waters":
      return "fas fa-tint";
    case "drinks":
      return "fas fa-cocktail";
    case "spirits":
      return "fas fa-glass-martini";
    case "mixers":
      return "fas fa-blender";
    default:
      return "";
  }
};
